<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <FormEditorUI :formSchema="initFormSchema" :duplicateFlg="duplicateFlg" id="formEditorUi"/>
      </v-col>
      <v-col cols="auto" class="ml-4" id="liff-preview">
        <div :class="{ 'fixed-preview': fixedPreview }">
          <SurveyPreview />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";
import FormEditorUI from "../components/FormEditor/FormEditorUI.vue";
import SurveyPreview from "./SurveyPreview.vue";
import debounce from "lodash/debounce";

// import base style
export default Vue.extend({
  props: {
    isBlank: Boolean,
    duplicateFlg: Boolean,
  },
  data() {
    return {
      model: {},
      editMode: 1,
      panel: 0,
      sourceJson: [],
      formData: {},
      selectedLang: "ja",
      dialog: false,
      initFormSchema: [],
      fixedPreview: false,
    };
  },
  watch: {},
  computed: {
    primaryColor() {
      return this.$vuetify.theme.themes.light.primary;
    },
  },
  components: { 
    FormEditorUI, 
    SurveyPreview 
  },
  methods: {
    onScroll() {
      var previewElement = document.getElementById("liff-preview");

      if (!this.isMenuVertical && window.scrollY > previewElement.offsetTop + 65) {
        this.fixedPreview = true;
      } else {
        this.fixedPreview = false;
      }
    },
  },
  created() {
    if (this.isBlank) {
      this.initFormSchema = [];
    }
    this.handleDebouncedScroll = debounce(this.onScroll, 0);
    window.addEventListener("scroll", this.handleDebouncedScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleDebouncedScroll);
  },
});
</script>

<style lang="less">
#formEditorUi {
  min-height:640px;
}

.confirmation-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
  .confirm-title {
    background: rgba(0, 0, 0, 0.04);
  }
}
#liff-preview {
  width: 360px;
}

.fixed-preview {
  position: fixed;
  top: 60px;
}
</style>
